export const SegmentLensAbi = [
  {
    inputs: [
      {
        internalType: 'contract SeToken',
        name: 'seToken',
        type: 'address',
      },
    ],
    name: 'seTokenMetadata',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'seToken', type: 'address' },
          {
            internalType: 'uint256',
            name: 'exchangeRateCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'reserveFactorMantissa',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalBorrows',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalReserves',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalSupply',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalCash', type: 'uint256' },
          { internalType: 'bool', name: 'isListed', type: 'bool' },
          {
            internalType: 'uint256',
            name: 'collateralFactorMantissa',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'underlyingAssetAddress',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'seTokenDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'underlyingDecimals',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'segmentSupplySpeed',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'segmentBorrowSpeed',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'dailySupplySef',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'dailyBorrowSef',
            type: 'uint256',
          },
        ],
        internalType: 'struct SegmentLens.SeTokenMetadata',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
